import React from 'react'

const AdminSignup = () => {
  return (
    <div>AdminSignup</div>
  )
}

export default AdminSignup